(function() {
  var productCache = new Map();
  var modal = null;
  var modalState = {
    product: null,
    selected: [],
    currency: "USD",
    skipNextImageSync: false
  };
  var modalImageSwapState = {};
  var modalImageLoadingIndicator = null;

  function getImageLoader() {
    return window.DennerImageLoader || null;
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function moneyFromCents(cents, currency) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: currency || "USD" }).format(value);
    } catch (error) {
      return "$" + value.toFixed(2);
    }
  }

  function normalizeImageUrl(url) {
    if (!url) return "";
    var value = String(url);
    if (value.indexOf("//") === 0) return window.location.protocol + value;
    return value;
  }

  function resolveImageData(imageLike, fallbackAlt) {
    if (!imageLike) {
      return { url: "", alt: fallbackAlt || "" };
    }
    if (typeof imageLike === "string") {
      return { url: normalizeImageUrl(imageLike), alt: fallbackAlt || "" };
    }
    if (typeof imageLike === "object") {
      return {
        url: normalizeImageUrl(imageLike.url || imageLike.src || ""),
        alt: imageLike.alt || fallbackAlt || ""
      };
    }
    return { url: "", alt: fallbackAlt || "" };
  }

  function resolveVariantImage(product, variant) {
    if (variant) {
      if (variant.featured_image) {
        return resolveImageData(variant.featured_image, product && product.title ? product.title : "");
      }
      if (variant.featured_media && variant.featured_media.preview_image) {
        return resolveImageData(variant.featured_media.preview_image, product && product.title ? product.title : "");
      }
    }
    var featured = product && (product.featured_image || product.images && product.images[0]);
    return resolveImageData(featured, product && product.title ? product.title : "");
  }

  function getHandleFromUrl(url) {
    if (!url) return "";
    var match = String(url).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  }

  function getOptionName(optionConfig, index) {
    if (typeof optionConfig === "object" && optionConfig !== null) {
      return String(optionConfig.name || ("Option " + (index + 1)));
    }
    return String(optionConfig || ("Option " + (index + 1)));
  }

  function findVariant(product, selected) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(function(variant) {
      if (!variant) return false;
      return selected.every(function(value, index) {
        return String(variant["option" + (index + 1)] || "") === String(value || "");
      });
    }) || null;
  }

  function findVariantInList(variants, selected) {
    if (!Array.isArray(variants)) return null;
    return variants.find(function(variant) {
      if (!variant) return false;
      return selected.every(function(value, index) {
        return String(variant["option" + (index + 1)] || "") === String(value || "");
      });
    }) || null;
  }

  function ensureModal() {
    if (modal) return modal;

    var container = document.createElement("div");
    container.className = "quick-buy-modal";
    container.setAttribute("data-quick-buy-modal", "");
    container.setAttribute("hidden", "");
    container.innerHTML = [
      '<div class="quick-buy-modal__backdrop" data-quick-buy-close></div>',
      '<div class="quick-buy-modal__sheet" role="dialog" aria-modal="true" aria-label="Quick buy">',
      '<button type="button" class="quick-buy-modal__close" aria-label="Close quick buy" data-quick-buy-close>&times;</button>',
      '<div class="quick-buy-modal__main">',
      '<a class="quick-buy-modal__media" data-quick-buy-modal-link href="#"><img data-quick-buy-modal-image alt="" loading="lazy"></a>',
      '<div class="quick-buy-modal__content">',
      '<p class="quick-buy-modal__kicker">Quick buy</p>',
      '<div class="quick-buy-modal__headline">',
      '<h3 class="quick-buy-modal__title"><a data-quick-buy-modal-title-link href="#" data-quick-buy-modal-title></a></h3>',
      '<p class="quick-buy-modal__price" data-quick-buy-modal-price></p>',
      '</div>',
      '<form class="quick-buy-modal__form" data-quick-buy-modal-form>',
      '<div class="quick-buy-modal__options" data-quick-buy-modal-options></div>',
      '<input type="hidden" name="id" data-quick-buy-modal-variant-id>',
      '<div class="quick-buy-modal__actions">',
      '<button type="submit" class="quick-buy-modal__submit" data-quick-buy-modal-submit>Add to cart</button>',
      '<a class="quick-buy-modal__view" data-quick-buy-modal-view href="#">View product</a>',
      '</div>',
      '</form>',
      '<p class="quick-buy-modal__status" data-quick-buy-modal-status></p>',
      '</div>',
      '</div>',
      '</div>'
    ].join("");

    document.body.appendChild(container);
    modal = container;
    var modalMedia = modal.querySelector(".quick-buy-modal__media");
    var imageLoader = getImageLoader();
    if (modalMedia && imageLoader && typeof imageLoader.createLoadingIndicatorController === "function") {
      modalImageLoadingIndicator = imageLoader.createLoadingIndicatorController(modalMedia, {
        activeClass: "is-loading",
        leavingClass: "is-loading-leaving",
        showDelayMs: 90,
        minVisibleMs: 140,
        fadeMs: 220
      });
    }

    modal.addEventListener("click", function(event) {
      if (event.target.closest("[data-quick-buy-close]")) {
        closeModal();
      }
    });

    var form = modal.querySelector("[data-quick-buy-modal-form]");
    form.addEventListener("submit", function(event) {
      event.preventDefault();
      submitModal();
    });

    document.addEventListener("keydown", function(event) {
      if (event.key === "Escape" && !modal.hasAttribute("hidden")) {
        closeModal();
      }
    });

    return modal;
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute("hidden", "");
    document.documentElement.classList.remove("quick-buy-modal-open");
  }

  function setModalImage(image, useTransition) {
    if (!modal) return;
    var imageEl = modal.querySelector("[data-quick-buy-modal-image]");
    var mediaWrap = modal.querySelector(".quick-buy-modal__media");
    if (!imageEl || !mediaWrap) return;

    var src = image && image.url ? image.url : "";
    var alt = image && image.alt ? image.alt : "";
    var currentSrc = imageEl.getAttribute("src") || "";
    if (!src) {
      imageEl.removeAttribute("src");
      imageEl.setAttribute("alt", alt);
      if (modalImageLoadingIndicator) modalImageLoadingIndicator.setLoading(false);
      return;
    }
    if (!useTransition || src === currentSrc) {
      imageEl.setAttribute("src", src);
      imageEl.setAttribute("alt", alt);
      if (modalImageLoadingIndicator) modalImageLoadingIndicator.setLoading(false);
      return;
    }

    var imageLoader = getImageLoader();
    if (imageLoader && typeof imageLoader.runImageSwapTransition === "function") {
      imageLoader.runImageSwapTransition({
        state: modalImageSwapState,
        targetImage: imageEl,
        mount: mediaWrap,
        src: src,
        srcset: "",
        alt: alt,
        durationMs: 320,
        slideOffset: "12%",
        overlayClassName: "quick-buy-modal__image-overlay",
        onLoadingChange: function(isLoading) {
          if (modalImageLoadingIndicator) modalImageLoadingIndicator.setLoading(!!isLoading);
        }
      });
      return;
    }

    imageEl.setAttribute("src", src);
    imageEl.setAttribute("alt", alt);
    if (modalImageLoadingIndicator) modalImageLoadingIndicator.setLoading(false);
  }

  function populateOptions(product, selected) {
    var optionsWrap = modal.querySelector("[data-quick-buy-modal-options]");
    optionsWrap.innerHTML = "";

    if (!Array.isArray(product.options) || !product.options.length) return;
    var availableVariants = Array.isArray(product.variants)
      ? product.variants.filter(function(variant) { return variant && variant.available; })
      : [];

    product.options.forEach(function(optionConfig, index) {
      var optionName = getOptionName(optionConfig, index);
      var optionNameLower = optionName.toLowerCase();

      var values = [];
      if (typeof optionConfig === "object" && optionConfig !== null && Array.isArray(optionConfig.values) && optionConfig.values.length) {
        var allowed = {};
        availableVariants.forEach(function(variant) {
          var variantValue = variant["option" + (index + 1)];
          if (variantValue != null) allowed[String(variantValue)] = true;
        });
        values = optionConfig.values.filter(function(value) { return !!allowed[String(value)]; });
      } else {
        availableVariants.forEach(function(variant) {
          var value = variant["option" + (index + 1)];
          if (value != null && values.indexOf(value) === -1) values.push(value);
        });
      }

      if (!values.length) {
        return;
      }
      if (optionNameLower.indexOf("gender") !== -1 && values.length <= 1) {
        selected[index] = values[0] || selected[index];
        return;
      }
      if (values.indexOf(selected[index]) === -1) {
        selected[index] = values[0];
      }

      var field = document.createElement("label");
      field.className = "quick-buy-modal__field";

      var label = document.createElement("span");
      label.className = "quick-buy-modal__label";
      label.textContent = optionName;
      field.appendChild(label);

      var select = document.createElement("select");
      select.className = "quick-buy-modal__select";
      select.setAttribute("data-quick-buy-option", String(index));

      values.forEach(function(value) {
        var opt = document.createElement("option");
        opt.value = value;
        opt.textContent = value;
        if (String(selected[index] || "") === String(value)) opt.selected = true;
        select.appendChild(opt);
      });

      select.addEventListener("change", function() {
        modalState.selected[index] = select.value;
        syncModalVariant();
      });

      field.appendChild(select);
      optionsWrap.appendChild(field);
    });
  }

  function syncModalVariant() {
    if (!modalState.product) return;

    var product = modalState.product;
    var variantsPool = Array.isArray(product.variants) ? product.variants.slice() : [];
    var availablePool = variantsPool.filter(function(item) { return item && item.available; });
    var selectedVariant = findVariantInList(variantsPool, modalState.selected);
    var active = findVariantInList(availablePool, modalState.selected) || availablePool[0] || null;

    var variantInput = modal.querySelector("[data-quick-buy-modal-variant-id]");
    var priceEl = modal.querySelector("[data-quick-buy-modal-price]");
    var submitEl = modal.querySelector("[data-quick-buy-modal-submit]");
    var statusEl = modal.querySelector("[data-quick-buy-modal-status]");

    if (!active) {
      variantInput.value = "";
      priceEl.textContent = "";
      submitEl.disabled = true;
      submitEl.textContent = "Unavailable";
      statusEl.textContent = "This combination is unavailable.";
      var unavailableImage = resolveVariantImage(product, null);
      setModalImage(unavailableImage, true);
      return;
    }

    var imageVariant = selectedVariant || active;
    var variantImage = resolveVariantImage(product, imageVariant);
    if (modalState.skipNextImageSync) {
      modalState.skipNextImageSync = false;
    } else {
      setModalImage(variantImage, true);
    }

    variantInput.value = String(active.id);
    priceEl.textContent = moneyFromCents(active.price, modalState.currency);

    if (selectedVariant && !selectedVariant.available) {
      submitEl.disabled = true;
      submitEl.textContent = "Sold out";
    } else {
      submitEl.disabled = false;
      submitEl.textContent = "Add to cart";
    }
  }

  function openModalWithProduct(productData, button) {
    ensureModal();

    var product = productData;
    var availablePool = product.variants.filter(function(item) { return item && item.available; });
    var firstAvailable = availablePool[0] || product.variants.find(function(item) { return item.available; }) || product.variants[0] || null;
    modalState.product = product;
    modalState.currency = button && button.dataset.currency ? button.dataset.currency : "USD";
    modalState.selected = firstAvailable
      ? [firstAvailable.option1, firstAvailable.option2, firstAvailable.option3].filter(function(item, index) {
          return Array.isArray(product.options) && index < product.options.length;
        })
      : [];

    var productLink = modal.querySelector("[data-quick-buy-modal-link]");
    var titleLink = modal.querySelector("[data-quick-buy-modal-title-link]");
    var titleEl = modal.querySelector("[data-quick-buy-modal-title]");
    var viewEl = modal.querySelector("[data-quick-buy-modal-view]");
    var statusEl = modal.querySelector("[data-quick-buy-modal-status]");

    var featured = product.featured_image || product.images && product.images[0];
    var image = resolveImageData(featured, product.title || "");
    var initialVariantImage = resolveVariantImage(product, firstAvailable);

    productLink.href = product.url || "#";
    titleLink.href = product.url || "#";
    viewEl.href = product.url || "#";
    titleEl.textContent = product.title || "";
    setModalImage(initialVariantImage.url ? initialVariantImage : image, false);
    statusEl.textContent = "";

    modalState.skipNextImageSync = true;
    populateOptions(product, modalState.selected);
    syncModalVariant();

    modal.removeAttribute("hidden");
    document.documentElement.classList.add("quick-buy-modal-open");
  }

  function submitModal() {
    if (!modalState.product) return;

    var variantInput = modal.querySelector("[data-quick-buy-modal-variant-id]");
    var submitEl = modal.querySelector("[data-quick-buy-modal-submit]");
    var statusEl = modal.querySelector("[data-quick-buy-modal-status]");
    var id = Number(variantInput.value || 0);
    if (!id) {
      statusEl.textContent = "Please select an available option.";
      return;
    }

    submitEl.disabled = true;
    submitEl.textContent = "Adding...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function(response) {
        if (!response.ok) throw new Error("add_failed");
        return response.json();
      })
      .then(function(addedItem) {
        var cartAddEvent = new CustomEvent("denner:cart:item-added", {
          bubbles: true,
          cancelable: true,
          detail: {
            source: "quick-buy-strip",
            item: addedItem || null
          }
        });
        var shouldOpenCart = document.documentElement.dispatchEvent(cartAddEvent);
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        if (shouldOpenCart) {
          var cartToggle = document.querySelector("[data-cart-toggle]");
          if (cartToggle) {
            cartToggle.dispatchEvent(new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window
            }));
          }
        }
        closeModal();
      })
      .catch(function() {
        submitEl.disabled = false;
        submitEl.textContent = "Add to cart";
        statusEl.textContent = "Could not add this item. Try again.";
      });
  }

  function openQuickBuy(button) {
    var handle = button.dataset.productHandle || getHandleFromUrl(button.dataset.productUrl);
    if (!handle) return;

    if (productCache.has(handle)) {
      openModalWithProduct(productCache.get(handle), button);
      return;
    }

    var wasDisabled = button.disabled;
    button.disabled = true;
    var originalText = button.textContent;
    button.textContent = "Loading...";

    fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function(response) { return response.ok ? response.json() : null; })
      .then(function(data) {
        if (!data || !Array.isArray(data.variants) || !data.variants.length) return;
        productCache.set(handle, data);
        openModalWithProduct(data, button);
      })
      .finally(function() {
        button.disabled = wasDisabled;
        button.textContent = originalText;
      });
  }

  function bindQuickBuyButtons() {
    document.addEventListener("click", function(event) {
      var button = event.target.closest("[data-quick-buy-open]");
      if (!button || button.disabled) return;
      event.preventDefault();
      openQuickBuy(button);
    });
  }

  function setupQuickBuyStrip(wrapper) {
    if (!wrapper || wrapper.dataset.quickBuyBound === "true") return;
    wrapper.dataset.quickBuyBound = "true";

    var track = wrapper.querySelector("[data-quick-buy-track]");
    var dots = Array.prototype.slice.call(wrapper.querySelectorAll("[data-quick-buy-dot]"));
    if (!track || dots.length < 2) return;

    var rafId = null;

    function setActiveDot(index) {
      dots.forEach(function(dot, dotIndex) {
        dot.classList.toggle("is-active", dotIndex === index);
      });
    }

    function currentIndex() {
      var slideWidth = track.clientWidth || 1;
      return Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / slideWidth)));
    }

    function onScroll() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function() {
        setActiveDot(currentIndex());
        rafId = null;
      });
    }

    track.addEventListener("scroll", onScroll, { passive: true });

    dots.forEach(function(dot, index) {
      dot.addEventListener("click", function() {
        track.scrollTo({ left: track.clientWidth * index, behavior: "smooth" });
      });
    });

    setActiveDot(0);
  }

  function buildSlideMarkup(product, heading, currency) {
    var featured = product.featured_image || product.images && product.images[0];
    var image = resolveImageData(featured, product.title || "");
    var imageUrl = image.url;
    var imageAlt = image.alt;

    var variant = null;
    if (Array.isArray(product.variants) && product.variants.length) {
      variant = product.variants.find(function(item) { return item.available; }) || product.variants[0];
    }
    if (!variant) return "";

    var slideImage = imageUrl
      ? '<a class="quick-buy-strip__media" href="' + escapeHtml(product.url) + '"><img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy"></a>'
      : '<a class="quick-buy-strip__media" href="' + escapeHtml(product.url) + '"></a>';

    var productHandle = product.handle || getHandleFromUrl(product.url);
    var buttonHtml = '<div class="quick-buy-strip__form"><button class="quick-buy-strip__button" type="button" data-quick-buy-open data-product-handle="' + escapeHtml(productHandle) + '" data-product-url="' + escapeHtml(product.url || "") + '" data-product-title="' + escapeHtml(product.title || "") + '" data-currency="' + escapeHtml(currency || "USD") + '" ' + (product.available === false ? "disabled" : "") + '>' + (product.available === false ? "Sold out" : "Quick buy") + "</button></div>";

    return (
      '<article class="quick-buy-strip__slide" data-quick-buy-slide>' +
        slideImage +
        '<div class="quick-buy-strip__content">' +
          '<p class="quick-buy-strip__kicker">' + escapeHtml(heading) + "</p>" +
          '<div class="quick-buy-strip__headline">' +
            '<h3 class="quick-buy-strip__title"><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + "</a></h3>" +
            '<p class="quick-buy-strip__price">' + escapeHtml(moneyFromCents(variant.price, currency)) + "</p>" +
          "</div>" +
          buttonHtml +
        "</div>" +
      "</article>"
    );
  }

  function hydrateLazyQuickBuy(wrapper, products) {
    var limit = Number(wrapper.dataset.limit || 4);
    var heading = wrapper.dataset.heading || "Complete the look";
    var currency = wrapper.dataset.currency || "USD";
    var htmlSlides = [];

    products.some(function(product) {
      if (!product || !product.id) return false;
      var markup = buildSlideMarkup(product, heading, currency);
      if (markup) htmlSlides.push(markup);
      return htmlSlides.length >= limit;
    });

    if (!htmlSlides.length) {
      wrapper.remove();
      return;
    }

    var dots = "";
    if (htmlSlides.length > 1) {
      var dotsItems = htmlSlides.map(function(_, index) {
        return '<button type="button" class="quick-buy-strip__dot' + (index === 0 ? " is-active" : "") + '" data-quick-buy-dot data-quick-buy-index="' + index + '" aria-label="Show item ' + (index + 1) + '"></button>';
      }).join("");
      dots = '<div class="quick-buy-strip__dots" aria-label="Quick buy items">' + dotsItems + "</div>";
    }

    wrapper.classList.remove("quick-buy-strip--loading");
    wrapper.removeAttribute("data-quick-buy-lazy");
    wrapper.setAttribute("aria-busy", "false");
    wrapper.innerHTML = '<div class="quick-buy-strip__track" data-quick-buy-track>' + htmlSlides.join("") + "</div>" + dots;
    setupQuickBuyStrip(wrapper);
  }

  function initLazyQuickBuy() {
    var lazyStrips = document.querySelectorAll("[data-quick-buy-lazy]");
    lazyStrips.forEach(function(wrapper) {
      if (wrapper.dataset.quickBuyLazyBound === "true") return;
      wrapper.dataset.quickBuyLazyBound = "true";

      var productId = wrapper.dataset.productId;
      var limit = Number(wrapper.dataset.limit || 4);
      if (!productId) {
        wrapper.remove();
        return;
      }

      var endpoint = "/recommendations/products.json?product_id=" + encodeURIComponent(productId) + "&limit=" + encodeURIComponent(limit) + "&intent=related";
      var controller = typeof AbortController !== "undefined" ? new AbortController() : null;
      var timeoutId = window.setTimeout(function() {
        if (controller) controller.abort();
        if (wrapper && wrapper.parentNode) wrapper.remove();
      }, 5000);

      fetch(endpoint, {
        credentials: "same-origin",
        signal: controller ? controller.signal : undefined
      })
        .then(function(response) { return response.ok ? response.json() : null; })
        .then(function(data) {
          window.clearTimeout(timeoutId);
          var products = data && Array.isArray(data.products) ? data.products : [];
          hydrateLazyQuickBuy(wrapper, products);
        })
        .catch(function() {
          window.clearTimeout(timeoutId);
          wrapper.remove();
        });
    });
  }

  function initQuickBuyStrips() {
    var strips = document.querySelectorAll("[data-quick-buy-strip]");
    strips.forEach(setupQuickBuyStrip);
    initLazyQuickBuy();
    bindQuickBuyButtons();
    ensureModal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initQuickBuyStrips);
  } else {
    initQuickBuyStrips();
  }
})();
